import { cleanCamelHash } from 'utils/questionnaireUtils';

// TODO: Make this a proper "type", rather that checking for equality against a certain set
// WIP: Should we add an answerKey for "signature"?
const answerKey = question =>
  question.elementType === 'checkbox' || question.elementType === 'tooth_selector'
    ? 'answers'
    : 'answer';

function removeVisibilityConditionalGroup(questionnaireItem) {
  // When we save a questionnaire, we do not want to persist the original conditional visibility
  // info from the questionnaire template, so we remove those keys from the JSON object/hash.
  const {
    visibilityConditionalGroup: _visibilityConditionalGroup, // eslint-disable-line no-unused-vars
    visibilityThenAction: _visibilityThenAction, // eslint-disable-line no-unused-vars
    ...remainingAttributes
  } = questionnaireItem;

  return remainingAttributes;
}

export default function convertFormToJSON(vals, questionnaire) {
  return {
    ...questionnaire,
    sections: questionnaire.sections.map(section =>
      removeVisibilityConditionalGroup({
        ...section,
        notes: vals[`${cleanCamelHash(section.title)}__notes`],
        questions: section.questions.map(question =>
          removeVisibilityConditionalGroup({
            ...question,
            [answerKey(question)]: vals[
              `${cleanCamelHash(section.title)}__${cleanCamelHash(question.prompt)}`
            ],
          })
        ),
      })
    ),
  };
}
